import { useQuery } from "@tanstack/react-query";
import { MaskedLine, Reveal } from "../components/Motion";
import WorkGrid from "../components/WorkGrid";
import ContactFooter from "../components/ContactFooter";
import { fetchCaseStudies } from "../lib/api";

export default function Work() {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["case-studies"],
        queryFn: fetchCaseStudies,
    });

    return (
        <main>
            <section className="px-5 md:px-10 pt-32 md:pt-40 pb-16 md:pb-24">
                <Reveal>
                    <p className="eyebrow mb-6 flex items-center gap-3">
                        <span className="h-2 w-2 rounded-full bg-vermilion animate-pulse" /> The work
                    </p>
                    <h1 className="display-hero font-display font-light text-paper">
                        <MaskedLine>
                            ALL<span className="text-vermilion"> WORK</span>
                        </MaskedLine>
                    </h1>
                    <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-vermilion">
                        * The principal consultant's personal track record — end-to-end engagements
                    </p>
                </Reveal>
            </section>

            <section className="px-5 md:px-10 pb-24 md:pb-32">
                {isLoading && (
                    <p className="py-20 font-mono text-xs uppercase tracking-[0.3em] text-smoke">
                        Loading the work…
                    </p>
                )}
                {isError && (
                    <p className="py-20 font-mono text-xs uppercase tracking-[0.3em] text-vermilion">
                        Couldn't load case studies — check the backend.
                    </p>
                )}
                {data && <WorkGrid items={data} />}
            </section>

            <ContactFooter />
        </main>
    );
}
